export const buildOfferListMarkerTooltipHtml = (params: {
    name: string;
    vendorName: string;
    countLabel: string;
}): string =>
    `<div style="border-radius: 8px; overflow: hidden; padding: 8px"><p style="font-size: 12.44px; font-weight: bold; margin: 0; padding: 0; line-height: 1.35">${params.name}</p><p style="font-size: 12px; margin: 0 0 3px 0; padding: 0; color: #ccc; line-height: 1.35">${params.vendorName}</p><p style="font-size: 12px; margin: 0; padding: 0; line-height: 1.35">${params.countLabel}</p></div>`;
